import ReactGA from 'react-ga';

class AnalyticsService {

  static instance;

  constructor () {
    if (!AnalyticsService.instance) {
      ReactGA.initialize('UA-45268707-1', {
        titleCase: false
      });
      AnalyticsService.instance = this;
    }
    return AnalyticsService.instance;
  }

  sendPageView = () => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  sendClick = (label, phoneNumber, priceDiff) => {
    ReactGA.event({
      label: label,
      category: 'jutalékriasztás',
      action: 'click',
      dimension1: phoneNumber,
      dimension2: priceDiff,
    });
  }

}

const instance = new AnalyticsService();
Object.freeze(instance);

export default instance;



// WEBPACK FOOTER //
// ./src/services/AnalyticsService/index.js